
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'container': {'width': `300px`,'display': `flex`,'flexDirection': `row`,'flexWrap': `no-wrap`,'alignItems': `center`,'justifyContent': `space-between`,'margin': `35px 0`,},'containerMobile': {'width': `300px`,'display': `flex`,'flexDirection': `row`,'flexWrap': `no-wrap`,'alignItems': `center`,'justifyContent': `space-between`,'margin': `35px 0`,'margin': `20px 0`,},'rectangle': {'width': `35px`,'height': `6px`,'backgroundColor': `"transparent"`,},'headerText': {'fontFamily': `'Lemon-Regular', sans-serif`,'fontSize': `30px`,'color': `#ffffff`,'width': `100%`,'textAlign': `center`,},
        
      };
    };
  